import Swiper from "swiper/bundle";

export default class BlogDetailsPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initSlider();
  }

  initSlider() {
    const sliderDOMs = this.dom.querySelectorAll(".module-slider");

    for (let slider of sliderDOMs) {
      const mainSlider = slider.querySelector(".main-slider");
      const thumbSlider = slider.querySelector(".thumbnail-slider");

      let thumbSwiper = new Swiper(thumbSlider, {
        loop: true,
        spaceBetween: 10,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
      });

      let mainSwiper = new Swiper(mainSlider, {
        loop: true,
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: thumbSwiper,
        },
      });
    }
  }

  resize() {}
}
